import type { ReactNode } from 'react'

interface Options {
  limit: 4 | 8
  showAll: boolean
}

export type PackageInclusionCategory = 'lux-plus' | 'exclusive' | 'night-extra' | 'standard'

export interface PackageInclusionsDisclosure {
  expanded: boolean
  onToggle: () => void
  contentId?: string
}

/** Product limits apply at every width; never hide just one or two remaining benefits. */
export function getVisiblePackageInclusionsCount(count: number, { limit, showAll }: Options): number {
  return showAll || count - limit <= 2 ? count : limit
}

/** A heading must not claim a threshold when any of its benefits has unknown bounds. */
export function getPackageInclusionsMinimumStay(inclusions: Array<App.OfferInclusion>): number | undefined {
  const minimumStay = inclusions[0]?.minDuration
  return minimumStay && minimumStay > 0 && inclusions.every(inclusion => inclusion.minDuration === minimumStay)
    ? minimumStay
    : undefined
}

export type PackageInclusionRow = {
  inclusion: App.OfferInclusion
  endIcon?: ReactNode
} | {
  id: string
  content: ReactNode
}

export interface PackageInclusionGroup {
  category: PackageInclusionCategory
  heading?: ReactNode
  rows: Array<PackageInclusionRow>
}

export interface PackageInclusionEntry {
  category: PackageInclusionCategory
  row: PackageInclusionRow
  heading?: ReactNode
}
